import RytmWebflow from 'rytm-webflow'
import { trace } from 'rytm-helpers'

class ModspectsController extends RytmWebflow.Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
  }
  addEventListeners() {
    super.addEventListeners();
    document.body.addEventListener('mouseover', this.onDocumentMouseOver);
    document.body.addEventListener('mouseout', this.onDocumentMouseOut);

  }
  removeEventListeners() {
    super.removeEventListeners()
    document.body.removeEventListener('mouseover', this.onDocumentMouseOver);
    document.body.removeEventListener('mouseout', this.onDocumentMouseOut);
  }

  // ### Event listeners
  onDocumentMouseOver = (e) => {
    const focustTo = e.target.closest('div[data-focus-point]');
    if (focustTo) {
      this.handleFocusPointOn(focustTo);
    }
  }
  onDocumentMouseOut = (e) => {
    const focustTo = e.target.closest('div[data-focus-point]');
    if (focustTo) {
      this.handleFocusPointOff(focustTo);
    }
  }
  // # Event handlers
  handleFocusPointOn = (el) => {
    const focusIndex = el.getAttribute('data-focus-point');
    if (el.classList.contains('is-hovered')) {
      return;
    }
    const list = [...document.querySelectorAll('div[data-focus-point="' + focusIndex + '"]')];
    list.forEach((el) => {
      el.classList.add('is-hovered');
    });
  }
  handleFocusPointOff = (el) => {
    const focusIndex = el.getAttribute('data-focus-point');
    if (!el.classList.contains('is-hovered')) {
      return;
    }
    const list = [...document.querySelectorAll('div[data-focus-point="' + focusIndex + '"]')];
    list.forEach((el) => {
      el.classList.remove('is-hovered');
    });
  }

}

export default ModspectsController;